import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { OptionStockManagementContainer } from "@/components/features/items/stock/option/ui";

import { useGetOptionStockPageParams } from "./_hooks/use-get-room-stock-page-params";

export const OptionStockPage = () => {
	const { hotelID } = useGetOptionStockPageParams();

	return (
		<PageMeta title="オプション在庫の設定" url={generatePath(PATHS.HOTEL.ITEMS.OPTION.STOCK, { hotelID })}>
			<OptionStockManagementContainer hotelID={hotelID} />
		</PageMeta>
	);
};

OptionStockPage.displayName = "OptionStockPage";
